let $theme_child = powergut_theme_child;


jQuery(document).ready(function() {
    initLabelMiniCart();
    initWoocommerceListView();
    addArrowFilterTitle();
    initPopupFilterBy();
    //addBtnPlusMinusQuantity();
    active_slick_wc_blocks();
    //initYithFilterCheckbox();

    if(jQuery('.pgut-pc-mega-menu').length > 0){
        loadBlockMegaMenu();
    }

    // Bouton flottant "Ajouter au panier", simuler le clic sur le bouton submit non flottant
    if(jQuery('.pgut-product__add-to-cart a').length > 0){
        jQuery('.pgut-product__add-to-cart a').click(function(){
            jQuery('form.cart button[type="submit"]').trigger('click');
        });
    }

    if(jQuery('#pgut-topbar').length > 0){
        // Disparition de la topbar
        hideHeaderTopBar();
    }

    /* Au scroll, montrer ou cacher header topbar */
    jQuery(window).scroll(function(){
        if(jQuery('#pgut-topbar').length > 0) {
            if (jQuery(document).scrollTop() > 200) {
                jQuery('#pgut-topbar').hide();
            } else if (jQuery(document).scrollTop() == 0) {
                if (jQuery('#pgut-topbar').is(":hidden")) {
                    jQuery('#pgut-topbar').show();
                }
            }
        }
    });
});

jQuery(document).on('change', '.pgut-variation-radios input', function(){
    changeDropdownProductVariations();
});

jQuery(document).on('ajaxComplete', function(event, request, setting){
    initYithFilterCheckbox();
});

function initLabelMiniCart(){
    jQuery('.pgut-block-wc-account-cart .pgut-label-button-cart').click(function(){
        jQuery('.wc-block-mini-cart__button').trigger('click');
    });
}

function initWoocommerceListView(){
    if(jQuery('.pgut-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)pgut_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            changeWoocommerceListView()
        }

        jQuery('.pgut-woocommerce-listing').on('click', function(){
            jQuery('.pgut-woocommerce-listing').removeClass('active');
            jQuery(this).addClass('active');
            var style_list = jQuery(this).attr('data-style');
            document.cookie = 'pgut_woocommerce_listing='+style_list+';';
            changeWoocommerceListView();
        });
    }
}

function changeWoocommerceListView(){
    if(jQuery('.pgut-woocommerce-listing').length > 0){
        var cookieNRWoocommerceListingValue = document.cookie.replace(/(?:(?:^|.*;\s*)pgut_woocommerce_listing\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if(cookieNRWoocommerceListingValue){
            jQuery('.wp-block-woocommerce-product-template .product').each(function(){
                jQuery(this).removeClass('grid list').addClass(cookieNRWoocommerceListingValue);
            });

            jQuery('.pgut-woocommerce-style-listing .pgut-woocommerce-listing').each(function(){
                jQuery(this).removeClass('active');
                jQuery('.pgut-shop-results').removeClass('grid list').addClass(cookieNRWoocommerceListingValue);

                if(jQuery(this).hasClass('pgut-woocommerce-listing__'+cookieNRWoocommerceListingValue)){
                    jQuery(this).addClass('active');
                }
            });
        }
    }
}

function changeDropdownProductVariations(){
    jQuery( '.pgut-variation-radios input:checked' ).each( function( index, element ) {
        const radio = jQuery(element);
        const radioName = radio.attr( 'name' )
        const radioValue  = radio.attr( 'value' )
        jQuery( 'select[name="' + radioName + '"]' ).val( radioValue ).trigger( 'change' );
    })
}

function addArrowFilterTitle(){
    if(jQuery('.archive.tax-product_cat .pgut-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').length > 0){
        jQuery('.archive.tax-product_cat .pgut-shop-sidebar .wc-blocks-filter-wrapper .wp-block-heading').each(function(index,element){
            jQuery('<img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/build/svg/icons-woocommerce/arrow-accordion-top.svg" alt="" />').appendTo(element);

            jQuery('.pgut-sidebar-shop > div:first-child .wc-blocks-filter-wrapper').addClass('active');
            jQuery('.pgut-sidebar-shop-technical-features > div:first-child .wc-blocks-filter-wrapper').addClass('active');

            jQuery(this).click( function(){
                jQuery(this).parent().toggleClass('active');
            })
        });
    }
}

function initPopupFilterBy(){
    jQuery('.pgut-shop-sidebar').each( function( element ) {
        $sidebar = jQuery(this);
        $button = jQuery('<button class="pgut-button pgut-open-popup pgut-icon__add pgut-icon__powergut-icon-filters">'+$theme_child["label_filters"]+'</button>').insertBefore('.pgut-shop-sidebar');

        $button.click(function(){
            $button.toggleClass('js-active');
            $sidebar.toggleClass('js-open');
        });
    });
}

/* Increase or decrease input number quantity thanks to span minus and plus */
function addBtnPlusMinusQuantity(){
    if(jQuery('.woocommerce input.qty:not([type=hidden])').length > 0){
        jQuery('.woocommerce input.qty:not([type=hidden])').each(function(){
            jQuery(this).before('<span class="pgut-btn-minus"><img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/assets/svg/icons-woocommerce/minus.svg" alt="Icône moins" /></span>');
            jQuery(this).after('<span class="pgut-btn-plus"><img src="/wp-content/themes/'+$theme_child["theme_slug"]+'/assets/svg/icons-woocommerce/plus.svg" alt="Icône plus" /></span>');

            jQuery('.pgut-btn-minus').click(function(){
                jQuery(this).next('.qty').val(Math.max(parseInt(jQuery(this).next('.qty').val())-1, 0));
            });

            jQuery('.pgut-btn-plus').click(function(){
                jQuery(this).prev('.qty').val(parseInt(jQuery(this).prev('.qty').val())+1);
            });
        });
    }
}

/* Cache la topbar du header */
function hideHeaderTopBar(){
    jQuery('#pgut-topbar .pgut-img-cross img').click( function(){
        jQuery('#pgut-topbar').remove();
    });
}

// Actions et événements liés au bloc mega menu
function loadBlockMegaMenu(){
    // Clic sur le menu burger
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__icons-menu').click(function(){
        //.pgut-pc-mega-menu
        jQuery(this).parent().toggleClass('open');
        jQuery('body').toggleClass('pgut-pc-mega-menu__open');
        jQuery('#pgut-logo-search').parent().toggleClass('pgut-header__content__dark-background');

        // Si le menu des catégories parentes et enfants ne contiennent pas la classe open
        // Alors on ajoute la classe open au menu des catégories parentes
        if(!jQuery(this).parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__children-product-categories').hasClass('open') && !jQuery(this).parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__parent-product-categories').hasClass('open')){
            jQuery(this).parents('.pgut-pc-mega-menu').find('.pgut-pc-mega-menu__parent-product-categories').toggleClass('open');
        }

    });

    // Clic sur le bouton "Fermer"
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__top-menu img:nth-of-type(2)').click(function(){
        jQuery(this).parents('.pgut-pc-mega-menu').removeClass('open');
        jQuery('#pgut-logo-search').parent().removeClass('pgut-header__content__dark-background');
    });

    // Clic sur le bouton "Suite" d'une catégorie pour voir les sous-catégories
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__parent-product-category.pgut-pc-mega-menu__parent-has-child').click(function(){
        var id_parent_category = jQuery(this).attr('data-id');
        var block_mega_menu = jQuery(this).parents('.pgut-pc-mega-menu');

        // Sur le bouton "Retour en arrière", on ajoute l'id de la catégorie parente
        // + on l'affiche
        block_mega_menu.find('.pgut-pc-mega-menu__top-menu').attr('data-id', id_parent_category).addClass('show');

        // Afficher le menu des catégories enfants
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().addClass('open');

        // Afficher le bon sous-menu des catégories enfant en fonction de la catégorie parent choisie
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').addClass('open');
        // Cacher tous les voisins de même niveau
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').siblings().removeClass('open');
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().next().removeClass('open');
        block_mega_menu.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_parent_category+'"]').parent().next().children().removeClass('open');
    });

    // Clic sur le bouton "Retour en arrière"
    jQuery('.pgut-pc-mega-menu .pgut-pc-mega-menu__top-menu img:first-child').click(function(){
        // Si le bouton a bien l'attribut data-id
        if(jQuery(this).parent().attr('data-id') != null){
            var id_back = jQuery(this).parent().attr('data-id');
            var menu_content = jQuery(this).parents('.pgut-pc-mega-menu__menu-content');

            // Afficher le menu des catégories parentes
            menu_content.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_back+'"]').toggleClass('open');
            menu_content.find('.pgut-pc-mega-menu__child-product-categories[data-id="'+id_back+'"]').parent().toggleClass('open');

            // Trouver l'id de la catégorie parente pour pouvoir refaire le "Retour arrière"
            var new_id_back = jQuery(".pgut-pc-mega-menu__children-product-categories.open .open").last().attr("data-id");
            if(new_id_back){
                jQuery(this).parent().attr('data-id', new_id_back);
            }
            else {
                // S'il n'y a pas d'id c'est qu'on est le sur le premier niveau dnc on enlève le bouton "Retour arrière"
                // Cacher l'icône "Retour en arrière"
                jQuery(this).parent().removeAttr('data-id').removeClass('show');
            }
        }
    });
}

function active_slick_wc_blocks(){
    jQuery('.powergut-slider__wc_slick').slick({
        "slidesToShow": 5,
        "slidesToScroll": 1,
        "dots": false,
        "responsive": [
            {
                "breakpoint":1439,
                "settings":{
                    slidesToShow: 4
                }
            },
            {
                "breakpoint":767,
                "settings":{
                    slidesToShow: 1
                }
            },
        ]
    });
}

function initYithFilterCheckbox(){
    if(jQuery('.yith-wcan-filters').length > 0){
        jQuery('.yith-wcan-filters').unbind('click').click(function(e){
            if(e.target.className == "filter-title"){
                e.target.parentElement.classList.toggle('js-close');
            }
        });
    }
}
